import BackgroundImage from "./../../components/ui/BackgroundImage";
import carsImage from "./assets/images/cars-bg.webp";
import WalkieTalkie from "./components/WalkieTalkie";
import { TalkieWalkieProvider } from "./hooks/use-talkie-walkie";

const index = ({ className = "" }: { className?: string }) => {
  return (
    <BackgroundImage
      imageSrc={carsImage}
      className={`relative h-screen overflow-hidden  ${className}`}
    >
      <TalkieWalkieProvider>
        <WalkieTalkie className="absolute bottom-10 right-10 nekst-font" />
      </TalkieWalkieProvider>
    </BackgroundImage>
  );
};

export default index;
